<div class="p-4">
  <app-modal-header
    [title]="'customShowcaseListSyncModalTitle' | translate"
    titleId="showcase-list-sync-dialog-title"
    closeId="close-showcase-list-sync-dialog-btn"
    [closeDisabled]="isSyncing"
    (close)="onClose()">
  </app-modal-header>
  <div class="modal-body">
    <div class="description-text">
      <p data-automation-id="showcase-list-sync-dialog-message" translate>
        customShowcaseListSyncModalConfirmMsg
      </p>
    </div>
    <div class="warn-color">
      <hr>
      <span class="warning-message-align">
        <span class="fa-regular fa-circle-exclamation fa-1x"></span>
        <span class="warning-message-text" data-automation-id="showcase-list-sync-dialog-warning" translate>
          customShowcaseListSyncModalWarningMsg
        </span>
      </span>
      <hr class="bottom-hr">
    </div>
    <section class="mt-4">
      <button
        type="button"
        class="ins-buttons button-primary flint"
        (click)="onConfirm()"
        [disabled]="isSyncing"
        data-automation-id="confirm-showcase-list-sync-dialog-btn"
        translate>
        customShowcaseListSyncModalConfirmBtn
      </button>
      <button
        type="button"
        class="ins-buttons button-secondary flint"
        (click)="onClose()"
        [disabled]="isSyncing"
        data-automation-id="cancel-showcase-list-sync-dialog-btn"
        translate>
        cancelCapitalized
      </button>
    </section>
  </div>
  <div aria-atomic="true" aria-live="assertive" role="alert">
    <p *ngIf="errorMessage"
       class="error-message py-2 px-3 text-center"
       data-automation-id="showcase-list-sync-dialog-error" translate>
      customShowcaseListSyncModalErrMsg
    </p>
  </div>
  <div class="d-flex justify-content-center text-white" role="status" aria-live="polite">
    <div *ngIf="isSyncing"
         class="hold-spinner-border spinner-border text-primary"
         data-automation-id="showcase-list-sync-dialog-spinner">
      <span class="sr-only" translate>Loading...</span>
    </div>
  </div>
</div>

